// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application Filters Styles
 * Styles for the application filters component - matching users page layout
 */

/* Filters Section */
.filters-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

/* Search and Filters Grid */
.search-filters-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: start;
}

.search-section {
  display: flex;
  flex-direction: column;
}

.filters-section-right {
  display: flex;
  flex-direction: column;
}

/* Align form groups properly */
.search-section .form-group,
/* Form Groups - Now using global styles from design-system.css */

.search-section .form-label,
.filters-section-right .form-label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

/* Ensure quick filters are properly aligned */
.filters-section-right .quick-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

/* Make sure search input and filters have similar heights */
.search-input-container {
  position: relative;
  min-height: 48px;
}

.filters-section-right .quick-filters {
  min-height: 48px;
  align-items: flex-start;
  padding-top: 10px;
}

.search-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border: none;
  border-radius: 8px;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.search-button:hover {
  background: linear-gradient(135deg, #C2410C, #FB923C);
  transform: translateY(-50%) scale(1.05);
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: translateY(-50%);
}

.form-input {
  width: 100%;
  padding: 12px 40px 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.form-input:disabled {
  background: #f7fafc;
  cursor: not-allowed;
}

/* Enhanced Quick Filters Section */
.quick-filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
  padding: 20px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.quick-filters::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.02) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.02) 0%, transparent 50%);
  pointer-events: none;
}

.quick-filter-btn {
  padding: 12px 20px;
  border: 2px solid transparent;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  color: #4a5568;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  min-width: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.quick-filter-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.quick-filter-btn:hover::before {
  left: 100%;
}

.quick-filter-btn:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
  color: #2d3748;
}

.quick-filter-btn.active {
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  color: white;
  border-color: transparent;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
}

.quick-filter-btn.active:hover {
  background: linear-gradient(135deg, #C2410C, #FB923C);
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4);
}

.quick-filter-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.quick-filter-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Responsive Design for Quick Filters */
@media (max-width: 768px) {
  .search-filters-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .quick-filters {
    gap: 8px;
    padding: 16px;
    margin-top: 12px;
  }

  .quick-filter-btn {
    padding: 10px 16px;
    font-size: 12px;
    min-width: 80px;
    border-radius: 10px;
  }

  .form-label {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .quick-filters {
    gap: 6px;
    padding: 12px;
    flex-direction: column;
  }

  .quick-filter-btn {
    padding: 12px 16px;
    font-size: 13px;
    min-width: 100%;
    border-radius: 8px;
  }

  .filters-section {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationFilters.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;;;wFAGsF;EACtF,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;oFAEkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Application Filters Styles\n * Styles for the application filters component - matching users page layout\n */\n\n/* Filters Section */\n.filters-section {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n}\n\n/* Search and Filters Grid */\n.search-filters-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n  align-items: start;\n}\n\n.search-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.filters-section-right {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Align form groups properly */\n.search-section .form-group,\n/* Form Groups - Now using global styles from design-system.css */\n\n.search-section .form-label,\n.filters-section-right .form-label {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n/* Ensure quick filters are properly aligned */\n.filters-section-right .quick-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* Make sure search input and filters have similar heights */\n.search-input-container {\n  position: relative;\n  min-height: 48px;\n}\n\n.filters-section-right .quick-filters {\n  min-height: 48px;\n  align-items: flex-start;\n  padding-top: 10px;\n}\n\n.search-button {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.search-button:hover {\n  background: linear-gradient(135deg, #C2410C, #FB923C);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.search-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: translateY(-50%);\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px 40px 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.form-input:disabled {\n  background: #f7fafc;\n  cursor: not-allowed;\n}\n\n/* Enhanced Quick Filters Section */\n.quick-filters {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n  padding: 20px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  position: relative;\n  overflow: hidden;\n}\n\n.quick-filters::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.02) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.02) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.quick-filter-btn {\n  padding: 12px 20px;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  color: #4a5568;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n  min-width: 100px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.quick-filter-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.5s;\n}\n\n.quick-filter-btn:hover::before {\n  left: 100%;\n}\n\n.quick-filter-btn:hover {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(102, 126, 234, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);\n  color: #2d3748;\n}\n\n.quick-filter-btn.active {\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  color: white;\n  border-color: transparent;\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n  transform: translateY(-2px);\n}\n\n.quick-filter-btn.active:hover {\n  background: linear-gradient(135deg, #C2410C, #FB923C);\n  transform: translateY(-3px);\n  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.4);\n}\n\n.quick-filter-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.quick-filter-btn:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Responsive Design for Quick Filters */\n@media (max-width: 768px) {\n  .search-filters-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .quick-filters {\n    gap: 8px;\n    padding: 16px;\n    margin-top: 12px;\n  }\n\n  .quick-filter-btn {\n    padding: 10px 16px;\n    font-size: 12px;\n    min-width: 80px;\n    border-radius: 10px;\n  }\n\n  .form-label {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .quick-filters {\n    gap: 6px;\n    padding: 12px;\n    flex-direction: column;\n  }\n\n  .quick-filter-btn {\n    padding: 12px 16px;\n    font-size: 13px;\n    min-width: 100%;\n    border-radius: 8px;\n  }\n\n  .filters-section {\n    padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
